"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenu = exports.DROPDOWN_MENU_PLACEMENT = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const downshift_1 = require("downshift");
const DropdownMenu_module_css_1 = __importDefault(require("./DropdownMenu.module.css"));
const react_1 = require("react");
// Placement refers to the pivot point of the menu.
// For example, a Top Left Placement mean that the menu's pivot point is the top egde and left corner of the trigger. And will flow to the direction of the trigger, i.e. right.
// Similarly, Right bottom means that the menu's pivot point is right edge and bottom corner of the trigger. And will flow to the direction of the trigger, i.e. up.
// Bottom Stretch and Top Stretch are special cases where the menu will stretch to the width of the trigger, and will flow up/down based on the pivot point
exports.DROPDOWN_MENU_PLACEMENT = {
    // TODO: Right now, we only have use for BOTTOM_STRETCH. Add more placements as needed.
    // TOP_LEFT: "TOP_LEFT",
    // TOP_RIGHT: "TOP_RIGHT",
    // RIGHT_TOP: "RIGHT_TOP",
    // RIGHT_BOTTOM: "RIGHT_BOTTOM",
    // BOTTOM_LEFT: "BOTTOM_LEFT",
    // BOTTOM_RIGHT: "BOTTOM_RIGHT",
    // LEFT_TOP: "LEFT_TOP",
    // LEFT_BOTTOM: "LEFT_BOTTOM",
    BOTTOM_STRETCH: "BOTTOM_STRETCH",
    // TOP_STRETCH: "TOP_STRETCH",
};
/**
 * Very Generic Dropdown Menu component. It is a wrapper around the downshift library.
 */
function DropdownMenu({ items, initialSelectedItem, toggleButtonRenderProps, itemRenderProps, placement = exports.DROPDOWN_MENU_PLACEMENT.BOTTOM_STRETCH, className, menuClassName, menuContainerClassName, }) {
    const { isOpen, selectedItem, getToggleButtonProps, getMenuProps, highlightedIndex, getItemProps, } = (0, downshift_1.useSelect)({
        items,
        itemToString: (item) => item?.ariaLabel ?? "",
        onSelectedItemChange: ({ selectedItem }) => {
            if (selectedItem?.onSelected) {
                selectedItem.onSelected();
            }
        },
        initialSelectedItem,
        // isOpen: true, // helpful for debugging purposes. Uncomment to help debug
    });
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, clsx_1.default)(DropdownMenu_module_css_1.default.dropdown, className), children: [toggleButtonRenderProps({
                getToggleButtonProps,
                isOpen,
                selectedItem,
            }), (0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(DropdownMenu_module_css_1.default.menuContainer, menuContainerClassName, {
                    // TODO: Add styles for all the placement types as cases for them come
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: Remove once we have more placement types
                    [DropdownMenu_module_css_1.default.bottomStretch]: placement === exports.DROPDOWN_MENU_PLACEMENT.BOTTOM_STRETCH,
                }), ...getMenuProps(), children: isOpen && ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(DropdownMenu_module_css_1.default.menu, menuClassName), children: items.map((item, index) => ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: itemRenderProps({
                            item,
                            index,
                            highlightedIndex,
                            getItemProps,
                            selectedItem,
                        }) }, `${item.ariaLabel}`))) })) })] }));
}
exports.DropdownMenu = DropdownMenu;
//# sourceMappingURL=index.js.map